import React from 'react';
import { IAutocompleteListboxProps } from './listbox.props';
import { useSetDefaultContainerStyle } from './hooks/use-set-container-style';

export const AutocompleteListbox = ({ children, addNewItemButton, ...props }: IAutocompleteListboxProps) => {
  const { containerStyle } = useSetDefaultContainerStyle(!!addNewItemButton.isHide);

  return (
    <div {...props} style={containerStyle}>
      {children}
    </div>
  );
};
